<template>
  <div class="custom-actions">
    <button class="btn btn-success btn-sm icon-pencil" title="Editar" v-on:click="editar"></button>
  </div>
</template>

<script>
  export default {
    name: 'actions-gitlab',

    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },

    methods: {
      editar() {
        this.$router.push({ path: `/projetos/sincronizar/${this.rowData.id}` });
      },
    },
  }
  </script>
